import { apiClient, toSignalError } from '@indipia/shared';
import type { SiteSignal, SiteSignalsResponse, TodosResponse } from '@indipia/shared';
import type { ApiResponse } from '@indipia/shared-types';

// 나의 할일·현장 신호 조회 — 52-Planner. 할일(TODO-01)은 제목·사유·버튼·이동 주소·NEW 까지 서버가 완성해 내려준다.
// 신호가 비면 서버가 503 SIGNAL_MISSING — SignalMissingError 로 던지며 폴백으로 덮지 않는다.

type Hdrs = Record<string, string | undefined>;

export interface GetTodosParams {
  /** today = 오늘 할일, week = 오늘 할일 + 오늘~6일 뒤 일정(weekDays) */
  scope: 'today' | 'week';
  siteId?: number;
  /** 생략하면 호출자(X-User-Id) */
  memberId?: number;
}

/** GET /schedule/todos?scope=today|week&siteId=&memberId= */
export async function getTodos(params: GetTodosParams, headers?: Hdrs): Promise<TodosResponse> {
  try {
    const res = await apiClient.get<ApiResponse<TodosResponse>>('/schedule/todos', {
      params: {
        scope: params.scope,
        ...(params.siteId != null && { siteId: params.siteId }),
        ...(params.memberId != null && { memberId: params.memberId }),
      },
      headers,
    });
    return res.data.data;
  } catch (e) {
    throw toSignalError(e);
  }
}

export interface GetSiteSignalsParams {
  siteIds?: number[];
  /** 현장 상태 필터 */
  status?: string;
}

/** GET /schedule/sites/signals?siteIds=&status= — 현장별 대표색·빨강/노랑 건수·최상위 사유 */
export async function getSiteSignals(params: GetSiteSignalsParams = {}, headers?: Hdrs): Promise<SiteSignal[]> {
  try {
    const res = await apiClient.get<ApiResponse<SiteSignalsResponse>>('/schedule/sites/signals', {
      params: {
        ...(params.siteIds && params.siteIds.length > 0 && { siteIds: params.siteIds.join(',') }),
        ...(params.status && { status: params.status }),
      },
      headers,
    });
    return res.data.data?.items ?? [];
  } catch (e) {
    throw toSignalError(e);
  }
}
